import { KeycloakConfig } from 'keycloak-js';
import { baseApi } from './baseApi'; // Define a service using a base URL and expected endpoints

export const publicApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOidcConfiguration: builder.query<KeycloakConfig, void>({
      query: () => `/public/oidc-configuration`,
    }),
  }),
});

export const { useGetOidcConfigurationQuery } = publicApi;
